import { ViewModel } from '../view-model';
export class EventStageStatus implements ViewModel {
  friendlyTypeNameSingular: string = 'Event Stage Status';
  apiRoute: string;

  id: string;
  eventId: string;
  processStageId: string;
  isComplete: boolean;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.eventId = data.eventId;
    this.processStageId = data.processStageId;
    this.isComplete = data.isComplete;
  }
}
